import { FileText, X } from "lucide-react";

function timeAgo(date) {
  if (!date) return "";
  const s = Math.max(1, Math.floor((Date.now() - date.getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}

/**
 * Slim banner shown at the top of a create page when a saved draft was
 * restored. "Discard" clears both localStorage AND the visible form.
 */
export default function DraftBanner({ restoredAt, onDiscard, testId = "draft-banner" }) {
  if (!restoredAt) return null;
  return (
    <div
      data-testid={testId}
      className="mb-4 flex items-center gap-3 rounded-2xl border border-violet-500/30 bg-violet-500/10 px-3 py-2 text-xs text-violet-100"
    >
      <FileText size={14} className="shrink-0" />
      <div className="flex-1">
        <span className="font-medium">Draft restored</span>
        <span className="ml-2 text-violet-300/80">saved {timeAgo(restoredAt)}</span>
      </div>
      <button
        data-testid={`${testId}-discard`}
        onClick={onDiscard}
        className="flex items-center gap-1 rounded-full bg-white/10 px-2.5 py-1 text-[11px] text-white/80 hover:bg-white/20"
      >
        <X size={10} /> Discard
      </button>
    </div>
  );
}
